


















import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { IFilterShowWith } from '@frontend/types/modules/content-filter/IContentFilter';

@Component({
	componentId: 'C044',
	components: {}
})
export default class FilterSwitch extends Vue {
	@Prop(String)
	protected readonly label!: string;

	@Prop(Number)
	protected readonly count?: number;

	@Prop([String, Number])
	protected readonly value!: string | number;

	@Prop(Boolean)
	protected checked?: boolean;

	@Prop(Boolean)
	protected disabled?: boolean;

	@Prop(Boolean)
	protected hidden?: boolean;

	@Prop(Boolean)
	protected readonly isHideable?: boolean;

	@Prop(Array)
	protected readonly showWith?: IFilterShowWith[];

	protected onChange(event: Event): void {
		this.$emit('input', (event.target as HTMLInputElement).checked);
	}
}
